import instance from 'services/api';
import {
  ADD_TABLE_POS,
  DELETE_TABLE_POS,
  GET_TABLE_POS,
  SET_LOADING_POS,
  UPDATE_TABLE_POS,
  LAST_CREATED_TABLE_POS,
} from 'redux/actions/types';
import { getSectionPOS } from 'redux/actions/Pos/sections';
import { toast } from 'react-toastify';
import {
  ensureTableInVisualization,
  removeTableFromVisualization,
  updateTableInVisualization,
} from 'pages/PosSettings/FloorPlan/syncCatalogToVisualization';

const businessUuidFromState = (getState) =>
  getState()?.business?.currentBusiness?.uuid || '';

export const getTablePOS = (businessUuid) => (dispatch, getState) => {
  const lastCreatedTableId = getState().pos.lastCreatedTable;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .get(`/cloud-pos/table`, {
      headers: {
        businessUuid: businessUuid,
      },
    })
    .then((response) => {
      const data = response?.data?.data;
      if (lastCreatedTableId) {
        const index = data.findIndex(
          (table) => table?.tableDetails?.uuid === lastCreatedTableId
        );
        if (index !== -1) {
          const [lastCreatedTable] = data.splice(index, 1);
          data.unshift(lastCreatedTable);
        }
      }
      dispatch({ type: GET_TABLE_POS, payload: data });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};

export const createTablePOS = (body) => (dispatch, getState) => {
  const tables = getState().pos.tables;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .post(`/cloud-pos/table`, body)
    .then(async (response) => {
      const data = response?.data?.data;
      const lastCreatedTableId =
        response?.data?.data?.tableDetails?.uuid || null;
      const filterTabled = tables.filter(
        (table) => table?.tableDetails?.uuid !== data?.tableDetails?.uuid
      );
      filterTabled.push(data);
      dispatch({ type: ADD_TABLE_POS, payload: filterTabled });
      dispatch({ type: LAST_CREATED_TABLE_POS, payload: lastCreatedTableId });
      dispatch({ type: SET_LOADING_POS, payload: false });

      const businessUuid =
        body?.businessUuid || businessUuidFromState(getState);
      const details = data?.tableDetails || {};
      await ensureTableInVisualization({
        businessUuid,
        uuid: details.uuid || lastCreatedTableId,
        sectionUuid: details.sectionUuid || body?.sectionUuid,
        name: details.name || body?.name,
        displayName: details.displayName || body?.displayName || body?.name,
        capacity:
          details.capacity !== undefined ? details.capacity : body?.capacity,
      });

      dispatch(getTablePOS(businessUuid));
      dispatch(getSectionPOS(businessUuid));
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toast.error(err?.response?.data?.message?.message || '');
      return Promise.reject(err);
    });
};

export const deleteTablePOS = (tableUuid) => (dispatch, getState) => {
  const tables = getState().pos.tables;
  const businessUuid = businessUuidFromState(getState);
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .delete(`/cloud-pos/table/${tableUuid}`)
    .then(async () => {
      const filterTabled = tables.filter(
        (table) => table?.tableDetails?.uuid !== tableUuid
      );
      dispatch({ type: DELETE_TABLE_POS, payload: filterTabled });
      dispatch({ type: SET_LOADING_POS, payload: false });

      await removeTableFromVisualization({
        businessUuid,
        uuid: tableUuid,
      });

      if (businessUuid) {
        dispatch(getTablePOS(businessUuid));
        dispatch(getSectionPOS(businessUuid));
      }
      return filterTabled;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};

export const updateTablePOS = (dataReq) => (dispatch, getState) => {
  const tables = getState().pos.tables;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .patch(`/cloud-pos/table/${dataReq.tableUuid}`, dataReq.body)
    .then(async (response) => {
      const data = response?.data?.data;
      const findIndex = tables.findIndex((table) => {
        return table?.tableDetails?.uuid === dataReq.tableUuid;
      });
      if (findIndex !== -1) {
        tables[findIndex] = data;
      }
      dispatch({ type: UPDATE_TABLE_POS, payload: tables });
      dispatch({ type: SET_LOADING_POS, payload: false });

      const businessUuid =
        dataReq.body?.businessUuid || businessUuidFromState(getState);
      const details = data?.tableDetails || {};
      await updateTableInVisualization({
        businessUuid,
        uuid: dataReq.tableUuid,
        sectionUuid: details.sectionUuid || dataReq.body?.sectionUuid,
        name: details.name || dataReq.body?.name,
        displayName:
          details.displayName ||
          dataReq.body?.displayName ||
          dataReq.body?.name,
        capacity:
          details.capacity !== undefined
            ? details.capacity
            : dataReq.body?.capacity,
      });

      dispatch(getTablePOS(businessUuid));
      dispatch(getSectionPOS(businessUuid));
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toast.error(err?.response?.data?.message?.message || '');
      return Promise.reject(err);
    });
};
